







import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    inheritAttrs: false,
})
export default class Loader extends Vue {
    @Prop() public readonly wide?: boolean;
}
